import * as CorporateListAction from './Action';
import * as GetReportByAction from './Action';
const initialState = {
    corporateList: [],
    corporateListError: [],
    reportByDate: [],
    reportByDateError: []
}

const MeteringStatsCorporateListReducer = (state = initialState, action) => {
    switch (action.type) {
        case CorporateListAction.LIST_CORPORATE_SUCCESS:
            return state = {
                ...state,
                corporateList: action.data
            }
        case CorporateListAction.LIST_CORPORATE_FAILURE:
            return state = {
                ...state,
                corporateListError: action.error
            }
        case GetReportByAction.REPORT_BY_DATE_SUCCESS:
            return state = {
                ...state,
                reportByDate: action.data
            }
        case GetReportByAction.REPORT_BY_DATE_FAILURE:
            return state = {
                ...state,
                reportByDateError: action.error
            }
            default: return state
    };
}

export default MeteringStatsCorporateListReducer;
